/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Favorite\UserFavRow.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Monday February 12th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday February 12th 2024 6:01:26 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { TableCell, TableRow } from "@mui/material";
import RouterPathResolver from "Config/Router/RouterPathResolver";
import { UserFav } from "Type/Favorites.type";
import { Link } from "react-router-dom";

export function UserFavRow(props: UserFav) {
    const tmpDate = new Date(props.CreatedAt);
    const style = {width:"33%"};

    return (
        <TableRow hover>
            <TableCell sx={style} align="center" className="text-capitalize">{tmpDate.toLocaleDateString()} {tmpDate.toLocaleTimeString()}</TableCell>
            <TableCell sx={style} align="center" className="text-capitalize">
                <Link to={RouterPathResolver.pathCar_BY_ID.path.replace(":id", props.Car.id)}>
                    {props.Car.Brand} {props.Car.Model}
                </Link>
            </TableCell>
            <TableCell sx={style} align="center" className="text-capitalize">{props.Car.RegNb}</TableCell>
            {/* <TableCell align="center" className="text-capitalize">
                <Link to={RouterPathResolver.pathSell_BY_ID.path.replace(":id", props.Sell.id)}>
                    {props.Sell.Name} / {translator.decode(`${props.Sell.Status}`) }
                </Link>
            </TableCell> */}
        </TableRow>
    )
}
